var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForecast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.143,
    height: 59.109,
    viewBox: "0 0 58.143 59.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.236,280H73.669a.969.969,0,0,0-.969.969v10.66H61.072v-6.783a.969.969,0,0,0-.969-.969H46.536a.969.969,0,0,0-.969.969V295.5h-12.6a.969.969,0,0,0-.969.969v9.691a.969.969,0,0,0,.969.969H87.236a.969.969,0,0,0,.969-.969v-25.2A.969.969,0,0,0,87.236,280Zm-53.3,17.443H45.567V305.2H33.938Zm13.567-.969v-10.66H59.134V305.2H47.5Zm13.567-2.907H72.7V305.2H61.072Zm25.2,11.629H74.638V281.938H86.267Z",
    transform: "translate(-30.061 -248.023)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.233,136H68.45v1.938h4.444L54.883,155.949,42,143.067a.969.969,0,0,0-1.371,0L18.342,165.355l1.371,1.37,21.6-21.6L54.2,158a.969.969,0,0,0,1.371,0l18.7-18.7v4.444H76.2v-6.783a.969.969,0,0,0-.969-.969Z",
    transform: "translate(-18.058 -121.466)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.552,233.6a13.535,13.535,0,0,1-3.26,1.809l.7,1.808a15.479,15.479,0,0,0,3.727-2.067Z",
    transform: "translate(-163.906 -207.247)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.371,46.476l.516-1.868a13.567,13.567,0,1,1,15.1-5.844L44.622,39.8a15.5,15.5,0,1,0-17.252,6.677Z",
    transform: "translate(-15.999 -16.025)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5,58.883a12.6,12.6,0,1,0-11.961,6.255l.159-1.932a10.6,10.6,0,0,1-3.579-.945l.947-1.641-1.678-.969-.946,1.639a10.59,10.59,0,0,1-2.562-2.561l1.64-.947L44.553,56.1l-1.64.947a10.617,10.617,0,0,1-.937-3.5h1.894V51.614H41.975a10.577,10.577,0,0,1,.938-3.5l1.639.946.969-1.678-1.637-.945a10.749,10.749,0,0,1,2.56-2.56l.945,1.637,1.678-.969-.946-1.639a10.576,10.576,0,0,1,3.5-.938v1.894H53.56V41.968a10.575,10.575,0,0,1,3.5.938l-.946,1.639,1.678.969.945-1.637a10.749,10.749,0,0,1,2.56,2.56l-1.637.945.969,1.678,1.639-.946a10.577,10.577,0,0,1,.938,3.5H61.312v1.938h1.893a10.638,10.638,0,0,1-1.38,4.36Z",
    transform: "translate(-37.085 -37.08)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.713,99.345l1.938-1.938a2.907,2.907,0,1,0,2.222-5.364V88h-1.938v4.043a2.906,2.906,0,0,0-1.654,3.993l-1.938,1.938Zm3.191-5.531a.969.969,0,1,1-.969.969A.969.969,0,0,1,110.9,93.814Z",
    transform: "translate(-95.399 -79.281)",
    fill: "#0080ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForecast);
export default __webpack_public_path__ + "static/media/forecast.f054be2f.svg";
export { ForwardRef as ReactComponent };